<template>
    <div>
        <toggle-button
           @change="change"
           :sync="true"
           :value="value" :height="getHeight" :width="getWidth"
           :labels="{checked: t(config.labels.checked), unchecked: t(config.labels.unchecked)}"
        />
    </div>
</template>

<script>

import ToggleButton from 'vue-js-toggle-button';
import Vue from "vue";
Vue.use(ToggleButton);

    export default {
        components: {},
        props: {
            config: {
                Type: Object,
                default: function () {
                    return {
                        labels: {
                            checked: 'Show filters',
                            unchecked: 'Hide filters'
                        },
                        description: null,
                        emitEvents: {},
                        value: false,
                        width: null,
                        height: null,
                    }
                }
            },
            eventBus: {
                Type: Object,
            },
        },
        data() {
            return {
                value: null,
                componentIndex: null,
                height: null,
                width: null,
            }
        },
        beforeDestroy() {
            this.unmountEvents();
        },
        inject: ['eventManager'],
        mounted() {
            this.init();
            this.mountEvents();
            this.eventManager.emitEvents(this.config.emitEvents['mounted'] || [], []);
        },
        methods: {
            init() {
                this.componentIndex = this.index;
                this.value = this.config.value;
                this.height = this.config.height;
                this.width = this.config.width;
            },
            mountEvents() {
                this.eventManager.bindEvents(this.defaultBindEvents(), this);
            },
            unmountEvents() {
                this.eventManager.unbindEvents(this.defaultBindEvents());
            },
            defaultBindEvents() {
                return [];
            },
            change() {
                this.value = !this.value;
                this.eventManager.emitEvents(this.config.emitEvents['change'] || [], this.value);
            }
        },
        computed: {
            getHeight() {
                return this.height || 25;
            },
            getWidth() {
                return this.width || 90;
            },
        }
    }
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// ToggleButtonComponent.vue?7e0438e8